export default __webpack_public_path__ + "static/media/nankebab.49ab1344.jpg";